import React from "react";
import {
    Box,
    Button,
    Dialog,
    DialogContent,
    IconButton,
    Typography,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import { Confirmacao, socioParaForm } from "./AdicionarSocioModal";

const PURPLE = "#9C01B9";
const TEXT = "#171717";
const MUTED = "#667085";
const BORDER = "#E5E7EB";

export default function VisualizarSocioModal({ open, onClose, onEditar, socio }) {
    if (!socio) return null;

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
            PaperProps={{
                sx: {
                    borderRadius: {
                        xs: 0,
                        sm: "12px",
                    },
                    overflow: "hidden",
                    margin: {
                        xs: 0,
                        sm: 2,
                    },
                    maxHeight: {
                        xs: "100%",
                        sm: "90vh",
                    },
                },
            }}
        >
            {/* HEADER */}
            <Box
                sx={{
                    px: {
                        xs: 2,
                        sm: 2.5,
                    },
                    py: 1.5,
                    backgroundColor: "#F5F6F8",
                    borderBottom: `1px solid ${BORDER}`,
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                    gap: 2,
                }}
            >
                <Box>
                    <Typography
                        sx={{
                            fontSize: {
                                xs: 16,
                                sm: 17,
                            },
                            fontWeight: 700,
                            color: TEXT,
                            lineHeight: 1.2,
                        }}
                    >
                        {socio.nome}
                    </Typography>

                    <Typography
                        sx={{
                            fontSize: 10,
                            color: MUTED,
                            mt: 0.4,
                        }}
                    >
                        Dados cadastrais do sócio
                    </Typography>
                </Box>

                <IconButton
                    onClick={onClose}
                    size="small"
                    sx={{
                        color: "#64748B",
                        mt: -0.5,
                        mr: -0.5,
                    }}
                >
                    <CloseIcon sx={{ fontSize: 17 }} />
                </IconButton>
            </Box>

            {/* CONTENT */}
            <DialogContent
                sx={{
                    px: {
                        xs: 2,
                        sm: 2.5,
                    },
                    py: {
                        xs: 2.5,
                        sm: 3,
                    },
                    backgroundColor: "#FFF",
                }}
            >
                <Confirmacao
                    form={socioParaForm(socio)}
                    titulo={null}
                    mostrarAviso={false}
                />
            </DialogContent>

            {/* FOOTER */}
            <Box
                sx={{
                    backgroundColor: "#F5F6F8",
                    borderTop: `1px solid ${BORDER}`,
                    px: {
                        xs: 2,
                        sm: 2.5,
                    },
                    py: 1.2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 1,
                }}
            >
                <Button
                    onClick={onClose}
                    sx={{
                        color: "#475467",
                        textTransform: "none",
                        fontSize: 11,
                        fontWeight: 500,
                    }}
                >
                    Fechar
                </Button>

                <Button
                    variant="contained"
                    startIcon={<EditIcon sx={{ fontSize: 13 }} />}
                    onClick={onEditar}
                    sx={{
                        minWidth: 78,
                        height: 34,
                        px: 2,
                        borderRadius: "8px",
                        backgroundColor: PURPLE,
                        color: "#FFF",
                        textTransform: "none",
                        fontSize: 11,
                        fontWeight: 700,
                        boxShadow: "none",
                        "&:hover": {
                            backgroundColor: "#85009E",
                            boxShadow: "none",
                        },
                    }}
                >
                    Editar sócio
                </Button>
            </Box>
        </Dialog>
    );
}
